// src/contexts/TenantSettingsContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/api';

const TenantSettingsContext = createContext({
  settings: null,
  loading: true,
  error: null,
  reload: () => {},
});

export function TenantSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      // 👉 Ici on utilise l'instance axios "api"
      // baseURL = ton backend local (ex: http://localhost:5000/api)
      const res = await api.get('/settings');

      const data = res.data || {};

      // On mappe un minimum pour avoir un "name"
      const mapped = {
        name: data.companyName || data.name || 'CABINET',
        ...data,
      };

      setSettings(mapped);
    } catch (err) {
      console.error('Erreur chargement settings:', err);
      setError(err);
      setSettings(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <TenantSettingsContext.Provider
      value={{ settings, loading, error, reload: load }}
    >
      {children}
    </TenantSettingsContext.Provider>
  );
}

export function useTenantSettings() {
  return useContext(TenantSettingsContext);
}
